<template>
  <a-modal title="发送报告" :visible="visible" :confirm-loading="loading" :mask-closable="false" width="720px" @ok="handleOk" @cancel="handleCancel">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
      <a-form-model-item label="推送类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio value="user">个人</a-radio>
          <a-radio value="chat">群聊</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="接收者" prop="receivers">
        <user-select v-if="form.type === 'user'" v-model="form.receivers" mode="multiple" show-search :show-all="false" :project-id="0" placeholder="请选择接收者" />
        <chat-select v-else v-model="form.receivers" placeholder="请选择群聊" />
      </a-form-model-item>
      <a-form-model-item label="报告标题" prop="title">
        <a-input v-model="form.title" />
      </a-form-model-item>
      <a-form-model-item label="推送内容">
        <div class="selected-problems">
          <div class="selected-problems__header">
            <span class="selected-count">已选择 {{ selectedProblems.length }} 条记录</span>
          </div>
          <div class="selected-problems__list">
            <div v-for="problem in selectedProblems" :key="problem.id" class="problem-item">
              <div class="problem-item__content">
                <span class="problem-id">PB-{{ problem.id }}</span>
                <span class="problem-name">{{ problem.title }}</span>
                <div class="problem-item__info">
                  <a-tag v-if="problem.status" :color="getStatusColor(problem.status)">{{ getStatusText(problem.status) }}</a-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import UserSelect from '@/components/User/UserSelect';
import ChatSelect from '@/components/FeiShu/ChatSelect';

import { problemSendReport } from '@/api/event/problem';
import { problemStatus, problemUrgencys } from '@/utils/dictionary';

export default {
  name: 'ProblemPushReportModal',
  components: {
    UserSelect,
    ChatSelect
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        type: 'user',
        receivers: [],
        title: '生产问题总结'
      },
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '请选择推送类型' }],
        receivers: [{ required: true, message: '请选择接收者', type: 'array' }]
      },
      selectedProblems: []
    };
  },
  methods: {
    open(problems) {
      this.visible = true;
      this.form.title = '生产问题总结';
      this.selectedProblems = problems;
    },
    resetForm() {
      this.form = {
        type: 'user',
        receivers: []
      };
      this.$refs.form && this.$refs.form.resetFields();
    },
    getStatusColor(status) {
      return problemStatus[status]?.color || 'default';
    },
    getStatusText(status) {
      return problemStatus[status]?.label || '--';
    },
    getUrgencyColor(urgency) {
      return problemUrgencys[urgency]?.color || 'default';
    },
    getUrgencyText(urgency) {
      return problemUrgencys[urgency]?.label || '--';
    },
    handleOk() {
      this.utils.trackClick({ name: '确认发送生产问题报告' });
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          problemSendReport({
            ids: this.selectedProblems.map(item => item.id),
            user_ids: this.form.receivers,
            title: this.form.title
          })
            .then(() => {
              this.$message.success('发送成功');
            })
            .finally(() => {
              this.loading = false;
              this.handleCancel();
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.resetForm();
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-modal-body) {
  padding: 16px;
}

:deep(.ant-form-item) {
  margin-bottom: 8px;
}

.selected-problems {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background: #fafafa;
  padding: 8px;

  &__header {
    line-height: 24px;
  }

  .selected-count {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }

  &__list {
    max-height: 360px;
    overflow-y: auto;
  }
}

.problem-item {
  padding: 8px 0;
  line-height: 24px;
  border-bottom: 1px dashed #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .problem-id {
    color: rgba(0, 0, 0, 0.45);
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .problem-name {
    color: rgba(0, 0, 0, 0.85);
    font-size: 13px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__info {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }
}
</style>
